export default class LangCache {
    private static lang: Record<string, string> = {};

    static setLang(value: Record<string, string>) {
        this.lang = value;
    }

    static getLang(): Record<string, string> {
        return this.lang;
    }
}